module.exports = __webpack_public_path__ + "img/2024-07.d758037a.jpg";